<template>
    <div v-if="loading == false">
        <div class="container mb-5">
            <div class="mt-4 mt-md-5">
                <div class="d-inline-block">
                    <h3 class="cR4" v-if="builder.approvalStatus == 0"><i>Pending Review</i></h3>
                    <h3 class="cR4" v-if="builder.approvalStatus == -1"><i>Denied In Review</i></h3>
                    <h2 class="text-light">{{ builder.name }}</h2>
                    <h4 class="text-secondary">
                        <span v-if="(builder.activeUntil != null || builder.activeUntil >= 0) && (builder.activeFrom != null || builder.activeFrom >= 0)" class="mt-3">
                            Active: {{ (builder.activeFrom == null || builder.activeFrom &#60; 0) ? 'Unknown' : builder.activeFrom }} -
                            <span v-if="!builder.activeUntil">Present</span><span v-if="builder.activeUntil">{{ builder.activeUntil &#60; 0 ? 'Unknown' : builder.activeUntil }}</span>
                        </span>
                        <span v-if="builder.city || builder.state || builder.country">
                            |</span>
                        <span v-if="builder.city || builder.neighborhood">{{ builder.city }}<span v-if="builder.neighborhood"> ({{builder.neighborhood}})</span>, </span><span v-if="builder.state">{{ builder.state
                        }}, </span>
                        {{ builder.country }}
                        <small class="d-block">Type: {{builderTypeOptions[builder.type]}}</small>
                        <small class="text-secondary"><i>Builder ID: {{builder.id}}</i></small>
                    </h4>
                </div>
                <div class="float-md-end d-inline-block">
                    <a :href="'/instruments?builder='+builder.name" class="btn btn-success me-1 mt-2 mt-md-0" target="_blank">View Instruments</a>
                    <a :href="'/instruments?extant=1&builder='+builder.name" class="btn btn-primary mt-3 mt-md-0" target="_blank">View Extant Instruments</a>
                </div>
            </div>

            <div class="row mt-4 mt-md-3">
                <div class="col-12 col-md-9">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Distinction:</h5>
                            <p class="card-text" style="white-space: pre-wrap;">
                                {{ builder.details }}
                                <span v-if="!builder.details">No additional details yet.</span>
                            </p>
                            <div class="accordion mb-3" id="accordionExample" v-if="builder.notes && builder.notes.length > 0">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="headingOne">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                            View Notes
                                        </button>
                                    </h2>
                                    <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                                        data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div v-for="(note, index) in builder.notes" v-bind:key="note.id" style="white-space: pre-wrap;">
                                                <hr v-if="index > 0">
                                                <i class="text-secondary">{{ note.modifiedName }} on {{getNoteDate(note)}}: </i>
                                                <small v-if="loggedIn">(<a :href="'/notes/'+note.id+'/edit'" target="_blank" class="cR4 text-decoration-none">Edit</a>/<a href="#details" @click="deleteNote(note.id)" class="cR4 text-decoration-none">Delete</a>) <span class="cR4" v-if="note.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="note.approvalStatus == -1"><i>Denied In Review</i></span></small>
                                                <div v-html="note.content" class="d-block"></div>
                                            </div>
                                            <p v-if="builder.notes.length == 0" class="mb-0">
                                                No notes have been written. If you have information, please consider sharing it with us.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion mt-3" id="recordingAccordion" v-if="recordingWebpages.length > 0">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="recordingHeadingOne">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#recordingCollapseOne" aria-expanded="false" aria-controls="recordingCollapseOne">
                                            View Recordings
                                        </button>
                                    </h2>
                                    <div id="recordingCollapseOne" class="accordion-collapse collapse" aria-labelledby="recordingHeadingOne"
                                        data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <ul>
                                                <li v-for="(webpage) in recordingWebpages" v-bind:key="webpage.id">
                                                    <a :href="webpage.url" target="_blank" class="text-decoration-none" data-bs-toggle="tooltip" v-bind:data-bs-title="webpage.description">{{webpage.name}}</a> <small v-if="loggedIn">(<a :href="'/webpages/'+webpage.id+'/edit'" target="_blank" class="cR4 text-decoration-none">Edit</a>/<a href="#details" @click="deleteWebpage(webpage.id)" class="cR4 text-decoration-none">Delete</a>) <span class="cR4" v-if="webpage.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="webpage.approvalStatus == -1"><i>Denied In Review</i></span></small></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion mt-3 mb-3" id="imageAccordion" v-if="builder.images.length > 0">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="imageHeadingOne">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#imageCollapseOne" aria-expanded="false" aria-controls="imageCollapseOne">
                                            View Images
                                        </button>
                                    </h2>
                                    <div id="imageCollapseOne" class="accordion-collapse collapse" aria-labelledby="imageHeadingOne"
                                        data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <MasonryWall :items="builder.images" :gap="30" :max-columns="5" :key="builder.images.length">
                                                <template #default="{ item }">
                                                    <div v-if="item.isPanoramic == 0">
                                                        <a v-bind:data-fancybox="0" v-bind:data-src="apiEndpoint + '/uploads/images/' + item.filename" v-bind:data-caption="item.name + ' | ' + item.source + getImageDate(item)"><img v-bind:src="apiEndpoint + '/uploads/images/' + item.fullThumbFilename" class="img-fluid w-100" /></a>
                                                    </div>
                                                    <div v-if="item.isPanoramic == 1">
                                                        <iframe height="300" allowfullscreen style="border-style: none; width: 100%" v-bind:src="'https://cdn.pannellum.org/2.5/pannellum.htm#panorama=' + apiEndpoint + '/uploads/images/' + item.filename + '&amp;preview=' + apiEndpoint + '/uploads/images/' + item.fullThumbFilename + '&amp;title=' + encodeURI(item.name) + '&amp;author=' + encodeURI(item.source + getImageDate(item))"></iframe>
                                                    </div>
                                                    <div class="mt-1" v-if="loggedIn">
                                                        <a :href="'/images/' + item.id + '/edit'" class="btn btn-sm btn-secondary me-1" target="_blank">Edit</a><button class="btn btn-sm btn-danger me-2" @click="deleteImage(item.id)">Delete</button><span class="cR4" v-if="item.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="item.approvalStatus == -1"><i>Denied In Review</i></span>
                                                    </div>
                                                </template>
                                            </MasonryWall>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion mt-3 mb-3" id="documentAccordion" v-if="builder.documents.length > 0">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="documentHeadingOne">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#documentCollapseOne" aria-expanded="false" aria-controls="documentCollapseOne">
                                            View Documents
                                        </button>
                                    </h2>
                                    <div id="documentCollapseOne" class="accordion-collapse collapse" aria-labelledby="documentHeadingOne"
                                        data-bs-parent="#accordionExample">
                                        <div class="accordion-body">
                                            <div v-for="document in builder.documents" v-bind:key="document.id">
                                                <p class="text-md-end mb-0"><a v-bind:href="apiEndpoint + '/uploads/documents/' + document.filename" target="_blank">Open In New Tab</a></p>
                                                <iframe v-bind:src="apiEndpoint + '/uploads/documents/' + document.filename" style="width: 100% !important; min-height: 60vh;"></iframe>
                                                <p v-if="document.description || document.originalDate"><b>Description:</b> {{document.description}} <span v-if="document.originalDate"><br v-if="document.description"><b>Originally Written/Published:</b> {{ getDate(document.originalDate) }}</span></p>
                                                <div v-if="loggedIn">
                                                    <a :href="'/documents/' + document.id + '/edit'" class="btn btn-sm btn-secondary me-1" target="_blank">Edit</a><button class="btn btn-sm btn-danger me-2" @click="deleteDocument(document.id)">Delete</button><span class="cR4" v-if="document.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="document.approvalStatus == -1"><i>Denied In Review</i></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p v-if="webpageWebpages.length > 0"><b>Webpage Links</b>: <span v-for="(webpage, index) in webpageWebpages" v-bind:key="webpage.id">
                                <span v-if="index > 0">, </span><a :href="webpage.url" target="_blank" class="text-decoration-none" data-bs-toggle="tooltip" v-bind:data-bs-title="webpage.description">{{webpage.name}}</a> <small v-if="loggedIn">(<a :href="'/webpages/'+webpage.id+'/edit'" target="_blank" class="cR4 text-decoration-none">Edit</a>/<a href="#details" @click="deleteWebpage(webpage.id)" class="cR4 text-decoration-none">Delete</a>) <span class="cR4" v-if="webpage.approvalStatus == 0"><i>Pending Review</i></span><span class="cR4" v-if="webpage.approvalStatus == -1"><i>Denied In Review</i></span></small></span>
                            </p>
                            <p class="editText mb-0">
                                <i class="me-2">Something missing or not quite correct?</i>
                                <a class="btn btn-sm btn-secondary me-2" :href="'/notes/add?builderIds='+builder.id" target="_blank">Add Note</a>
                                <i class="me-2">or</i>
                                <a class="btn btn-sm btn-secondary me-2" :href="'/webpages/add?builderIds='+builder.id" target="_blank">Add Webpage</a>
                                <i class="me-2">or</i>
                                <a class="btn btn-sm btn-secondary me-2" :href="'/images/add?builderIds='+builder.id" target="_blank">Add Image</a>
                                <i class="me-2">or</i>
                                <a class="btn btn-sm btn-secondary me-2" :href="'/documents/add?builderIds='+builder.id" target="_blank">Add Document</a>
                                <i class="me-2">or</i>
                                <a class="btn btn-sm btn-secondary me-2" :href="editBuilderLink" target="_blank"><span v-if="!loggedIn">Suggest an Edit</span><span v-else>Edit Builder</span></a>
                                <i v-if="loggedIn" class="me-2">or</i>
                                <button class="btn btn-sm btn-danger me-2" v-if="loggedIn" @click="deleteBuilder">Delete</button>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-3 mt-3 mt-md-0">
                    <div class="card mb-3" v-if="headerImage.filename != 'blank.png'">
                        <img v-bind:src="apiEndpoint + '/uploads/images/' + headerImage.filename" class="card-img-top" v-bind:alt="builder.name">
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Database Specs:</h5>
                            <p class="card-text">
                                <ul class="mb-0">
                                    <li>{{ builder.instrumentCount }} Instruments</li>
                                    <li>{{ builder.consoleCount }} Consoles</li>
                                    <li>{{ builder.blowerCount }} Blowers</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-if="loading == true" class="mt-5 text-center">
        <h1 class="d-inline-block me-3 text-secondary">Loading...</h1>
        <div class="spinner-border text-secondary d-inline-block" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</template>

<script>
    import BuilderService from "../services/builder.service";
    import NoteService from "../services/note.service";
    import WebpageService from "../services/webpage.service";
    import ImageService from "../services/image.service";
    import DocumentService from "../services/document.service";
    import ItemTypes from "../itemTypes";
    import moment from "moment";

    export default {
        name: "Builder",
        metaInfo() {
            return {
                title: this.builder && this.builder.name ? this.builder.name + ' | Pipe Organ Database' : 'Builder Details | Pipe Organ Database',
                meta: [
                    {
                        property: 'og:type',
                        name: 'og:type',
                        content: 'website'
                    },
                    {
                        property: 'og:title',
                        name: 'og:title',
                        content: this.builder && this.builder.name ? this.builder.name + ' | Pipe Organ Database' : 'Builder Details | Pipe Organ Database'
                    },
                    {
                        property: 'og:description',
                        name: 'og:description',
                        content: this.builder && this.builder.details ? this.builder.details.substr(0, 50) + "..." : ''
                    },
                    {
                        property: 'og:image',
                        name: 'og:image',
                        content: this.headerImage ? this.apiEndpoint + '/uploads/images/' + this.headerImage.fullThumbFilename : 'https://api.pipeorgandatabase.org/uploads/images/blank.png'
                    },
                    {
                        property: 'twitter:card',
                        name: 'twitter:card',
                        content: 'summary_large_image'
                    },
                    {
                        property: 'twitter:title',
                        name: 'twitter:title',
                        content: this.builder && this.builder.name ? this.builder.name + ' | Pipe Organ Database' : 'Builder Details | Pipe Organ Database'
                    },
                    {
                        property: 'twitter:description',
                        name: 'twitter:description',
                        content: this.builder && this.builder.details ? this.builder.details.substr(0, 50) : ''
                    },
                    {
                        property: 'twitter:image',
                        name: 'twitter:image',
                        content: this.headerImage ? this.apiEndpoint + '/uploads/images/' + this.headerImage.fullThumbFilename : 'https://api.pipeorgandatabase.org/uploads/images/blank.png'
                    }
                ]
            }
        },
        computed: {
            currentUser() {
                return this.$store.state.auth.user;
            },
            loggedIn() {
                return this.$store.state.auth.status.loggedIn;
            },
            apiEndpoint() {
                return process.env.VUE_APP_API_ENDPOINT;
            },
            editBuilderLink() {
                if (this.loggedIn) {
                    return '/builders/'+this.builder.id+'/edit';
                }
                return '/editRequests/add?itemCategory=1&itemType=0&itemId='+this.builder.id;
            },
            webpageWebpages() {
                return this.builder.webpages.filter((item) => {
                    return item.siteType == 0;
                });
            },
            recordingWebpages() {
                return this.builder.webpages.filter((item) => {
                    return item.siteType == 1;
                });
            },
        },
        data() {
            return {
                loading: true,
                builder: null,
                headerImage: null,
                builderTypeOptions: ItemTypes.builderTypes
            };
        },
        mounted() {
            this.loadInitial(this.$route.params.id);
        },
        methods: {
            loadInitial(id) {
                this.loading = true;
                BuilderService.get(id).then(
                    (response) => {
                        this.builder = response.data;
                        var headerImages = [];
                        this.builder.images.forEach((element) => {
                            if (element.isHeader == 1) {
                                headerImages.push(element);
                            }
                        });
                        this.headerImage = headerImages[Math.floor(Math.random() * headerImages.length)];
                        if (!this.headerImage || this.headerImage == null) {
                            this.headerImage = { filename: "blank.png", fullThumbFilename: "blank.png" };
                        }
                        this.loading = false;
                    },
                    (error) => {
                        console.log(error);
                        if (error.response && error.response.status) {
                            this.$router.push("/" + error.response.status);
                        }
                    }
                );
            },
            getImageDate(image) {
                if (image.dateTaken) {
                    return " on " + moment(image.dateTaken).format("MM/DD/YYYY");
                } else if (image.dateTakenApprox) {
                    return " approx. " + image.dateTakenApprox;
                }
                return "";
            },
            getDate(date) {
                if (date) {
                    return moment(date).format("MMMM Do, YYYY");
                }
                return "";
            },
            deleteBuilder() {
                if (confirm("Are you sure you want to delete this builder?")) {
                    BuilderService.delete(this.builder.id).then(
                        () => {
                            this.$router.push("/builders");
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            getNoteDate(note) {
                return moment(note.createdAt).format("MMMM Do, YYYY");
            },
            deleteNote(noteId) {
                if (confirm("Are you sure you want to delete this note?")) {
                    NoteService.delete(noteId).then(
                        () => {
                            this.loadInitial(this.builder.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            deleteWebpage(webpageId) {
                if (confirm("Are you sure you want to delete this webpage?")) {
                    WebpageService.delete(webpageId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            deleteImage(imageId) {
                if (confirm("Are you sure you want to delete this image?")) {
                    ImageService.delete(imageId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            },
            deleteDocument(documentId) {
                if (confirm("Are you sure you want to delete this document?")) {
                    DocumentService.delete(documentId).then(
                        () => {
                            this.loadInitial(this.instrument.id);
                        },
                        (error) => {
                            console.log(error);
                            if (error.response && error.response.status) {
                                this.$router.push("/" + error.response.status);
                            }
                        }
                    );
                }
            }
        },
    };
</script>